'use client';
import { usePathname } from 'next/navigation';
import React from 'react';
export default function usePathChanged(cb) {
    const pathname = usePathname();
    const prevPathnameRef = React.useRef(undefined);
    React.useEffect(()=>{
        if (pathname !== prevPathnameRef.current) {
            let result = undefined;
            if (typeof cb === 'function' && prevPathnameRef.current !== undefined) {
                result = cb(pathname);
            }
            prevPathnameRef.current = pathname;
            return result;
        }
        return undefined;
    }, [
        cb,
        pathname
    ]);
    return null;
}

//# sourceMappingURL=usePathChanged.js.map